import { useMutation, useQueryClient } from '@tanstack/react-query';
import { releaseUserEmail } from '../services/users';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';
import type { AdminUser } from '../types/users.types';

interface ReleaseEmailParams {
    id: string;
    confirmation: string;
}

export const useReleaseEmailMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<AdminUser, Error, ReleaseEmailParams>({
        mutationFn: ({ id, confirmation }) => releaseUserEmail(id, confirmation),
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries({ queryKey: userKeys.detail(id) });
            queryClient.invalidateQueries({ queryKey: userKeys.lists() });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
